export type FilterOperator = 'LIKE' | 'MINOR' | 'GREATER' | 'EQUAL' | 'IS_NOT_NULL';

export class SingleFilter {
  fields: string[] = [];
  value: string;
  partialMatch?: boolean = false;
  constructor(params: SingleFiltersParams) {
    this.fields = params.fields;
    this.value = params.value;
    this.partialMatch = params.partialMatch;
  }
}

export class FilterFields {
  fieldName: string;
  value?: string;
  values?: string[];
  partialMatch?: boolean = false;
  operator: FilterOperator;
  constructor(params: FilterFieldsParams) {
    this.fieldName = params.fieldName;
    this.value = params.value;
    this.values = params.values;
    this.partialMatch = params.partialMatch;
    this.operator = params.operator || 'LIKE';
  }
}

export class Filters {
  selectFields: string[];
  sort: [string, 'ASC' | 'DESC' | undefined][];
  limit: number;
  page: number;
  singleFilter: SingleFilter;
  filterFields: FilterFields[];
  orFilterFields: FilterFields[][];

  constructor(params: Params = {}) {
    this.selectFields = params.selectFields;
    this.sort = params.sort;
    this.limit = params.limit;
    this.page = params.page;
    this.singleFilter = params.singleFilter;
    this.filterFields = params.filterFields || [];
    this.orFilterFields = params.orFilterFields || [];
  }
}

interface Params {
  selectFields?: string[];
  sort?: [string, 'ASC' | 'DESC' | undefined][];
  limit?: number;
  page?: number;
  singleFilter?: SingleFilter;
  filterFields?: FilterFields[];
  orFilterFields?: FilterFields[][];
}

interface SingleFiltersParams {
  fields: string[];
  value: string;
  partialMatch?: boolean;
}

interface FilterFieldsParams {
  fieldName: string;
  value?: string;
  operator?: FilterOperator;
  values?: string[];
  partialMatch?: boolean;
}
